var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ad7uiv34ya"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.545098 0 0 0 0 0.564706 0 0 0 0 0.603922 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ad7uiv34ya)",
    transform: "translate(-764 -289) translate(342 64) translate(316 212)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.81 4.949c.123.148.34.166.485.04.015-.012.029-.025.04-.04l2.667-3.47c.114-.148.088-.363-.057-.48-.06-.046-.132-.072-.206-.072H-.593c-.184 0-.334.153-.334.342 0 .076.025.15.071.21L1.81 4.95z",
    transform: "translate(106 13) translate(3) rotate(-90 2.073 3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.81 4.949c.123.148.34.166.485.04.015-.012.029-.025.04-.04l2.667-3.47c.114-.148.088-.363-.057-.48-.06-.046-.132-.072-.206-.072H-.593c-.184 0-.334.153-.334.342 0 .076.025.15.071.21L1.81 4.95z",
    transform: "translate(106 13) rotate(-90 2.073 3)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.28c8189e.svg";
export { ForwardRef as ReactComponent };